export const getNeuralNodeSizes = (isMobile: boolean) => {
  const sizeClasses = {
    central: isMobile ? 'w-20 h-20' : 'w-32 h-32',
    large: isMobile ? 'w-16 h-16' : 'w-24 h-24',
    medium: isMobile ? 'w-12 h-12' : 'w-20 h-20', 
    small: isMobile ? 'w-8 h-8' : 'w-16 h-16'
  };
  
  const iconSizes = {
    central: isMobile ? 'w-10 h-10' : 'w-16 h-16',
    large: isMobile ? 'w-8 h-8' : 'w-12 h-12',
    medium: isMobile ? 'w-6 h-6' : 'w-10 h-10',
    small: isMobile ? 'w-4 h-4' : 'w-8 h-8'
  };

  return { sizeClasses, iconSizes };
};